import { render, staticRenderFns } from "./CardRenderEffectBoxComponent.vue?vue&type=template&id=296b6060"
import script from "./CardRenderEffectBoxComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderEffectBoxComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports